import React from 'react'
import ListingPage from "../pages/Listing";
import { getPageTitle } from "../utility/utility"

export default class ListingPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.toggleSaved = this.toggleSaved.bind(this)
  }

  static pageTitle(listings, routeParams) {
    const listingId = routeParams.location.query.id;

    // Handle the case where the listings haven't loaded yet.
    const listingsLoadedSuccessfully =
      typeof listings !== "undefined" && !(listings instanceof Error);

    return '300 Ashland' +
      (listingsLoadedSuccessfully && listings[listingId] ?
         ` | Apt ${listings[listingId].unitNumber}` :
         '');
  }

  componentDidMount() {
    this.props.syncListings({filters: {id: this.props.location.query.id}});
  }

  componentWillReceiveProps(nextProps) {
    this.props.syncListings({filters: {id: nextProps.location.query.id}});
  }

  toggleSaved() {
    this.props.toggleListingSaved(this.props.location.query.id);
  }

  render() {
    const listings = this.props.listings;
    const listingsLoadedSuccessfully =
      typeof listings !== "undefined" && !(listings instanceof Error);

    const listing = listingsLoadedSuccessfully ?
      listings[this.props.location.query.id] :
      listings;

    const similarListings = listingsLoadedSuccessfully && listing && listing.similar ?
      listing.similar.map(id => listings[id]) :
      [];

    return (
      <ListingPage
        {...this.props}
        listing={listing}
        similarListings={similarListings}
        toggleSaved={this.toggleSaved}
        pageTitle={getPageTitle(this.constructor, this.props)}
        openContactModal={this.props.openContactModal} />
    );
  }
}


// WEBPACK FOOTER //
// ./client/containers/ListingPageContainer.js